
import api from '../api'

export default {
	getOrderList(params,successCallback,errCallback = function () {}, isShowErrMsg = true){
		api.post('api/appclient/v2/order/list',params,successCallback, errCallback, isShowErrMsg)
	},
	getOrderDetails(params,successCallback,errCallback = function () {}, isShowErrMsg = true){
		const url = 'api/appclient/v2/order/detail/'+params;
		api.get(url,params,successCallback, errCallback, isShowErrMsg)
	},
	cancelOrder(params,successCallback,errCallback = function () {}, isShowErrMsg = true){
		const url = 'api/appclient/v2/order/cancelOrder';
		api.post(url,params,successCallback, errCallback, isShowErrMsg)
	},
	signOrder(orderCode,successCallback,errCallback = function () {}, isShowErrMsg = true){
		const url = 'api/appclient/v2/order/signOrder/'+orderCode;
		api.get(url,orderCode,successCallback, errCallback, isShowErrMsg)
	},
	getExpressList(orderCode,successCallback,errCallback = function () {}, isShowErrMsg = true){
		const url = 'api/appclient/v2/order/orderList/'+orderCode;
		api.post(url,orderCode,successCallback, errCallback, isShowErrMsg)
	},

} 



// WEBPACK FOOTER //
// ./src/api/orderManage/api.order.js